module.exports = __webpack_public_path__ + "rotate-ccw.svg?96d36a730fa7d592b370b7732e12146e";